import * as actionTypes from './actionsTypes';
import axios from 'axios';

export const GetUserId = () => {
    return dispatch => {
        axios
        .get(
          "https://dev.kulinarskeumeni.cz/api_interactive_presentation/get-user-id",
          {
              appId: 'KurzByk',

          }
        )
        .then(response => {
          console.log("Success:", JSON.stringify(response));
          console.log("Success:", response);
          dispatch(GetQuizState(response.data.userId));
         
        })
        .catch(error => {
          console.log("nepodarilo se fetchnout uzivatele");
          console.error("Error:", error);
          dispatch(GetQuizState(null));
          
        });
    }
}


export const GetQuizState = (userID) => {
return dispatch => {


        // FETCH QUIZ STATUS
    //  axios.get("https://dev.kulinarskeumeni.cz/api_interactive_presentation/get-quiz-protection",
    //  {
    //     appId: 'KurzByk',
    //     userId: userID
    //  }
    //  )
    //  .then(response => {
    //      console.log('Stav kvizu je :')
    //    console.log(response);
    //    dispatch(SetQuizState(response.data.quizProtection));
      
    //  }).catch(error => {
    //      console.log('nepovedlo se zjistit stav kvizu')
    //     dispatch(SetQuizState(false))
    //      dispatch(QuizFetchFailed(error))
    //     console.error('Error:', error)})

    // const isRunning = false;

    // setTimeout(() => {
    //     console.log('Kviz isRunning:', isRunning )
    //     dispatch(SetQuizState(isRunning))
    // },1000)


    fetch(
        "https://dev.kulinarskeumeni.cz/api_interactive_presentation/get-quiz-protection",
        {
          method: "POST",
          body: JSON.stringify({
            appId: 'KurzByk',
            userId: userID
          }),
          headers: {
            "Content-Type": "application/json"
          }
        }
      )
        .then(res => res.json())
        .then(response => {
            console.log('Stav kvizu je :')
          console.log("Success:", JSON.stringify(response));
          console.log("Success:", response);
          console.log("Success:", response.quizProtection);
          dispatch(SetQuizState(response.quizProtection));
          console.log("Quiz Zacal s timto Userem", userID);
        })
        .catch(error => {
        dispatch(SetQuizState(false))
          console.log("nepovedlo se zjistit stav kvizu");
          console.error("Error:", error);
        });
    
}

    

}

export const SetQuizState = (quizState) => {
    return {
        type: actionTypes.QUIZ_PROTECTION_VALUE,
        isQuizRunning: quizState
    }
}

export const QuizFetchSuccess = () => {
    return {
        type: actionTypes.QUIZ_PROTECTION_FETCH_SUCCESS
    }
}

export const QuizFetchFailed = (error) => {
    return {
        type: actionTypes.QUIZ_PROTECTION_FETCH_FAIL
    }
} 